const single_sign_on = {
    forbidden_domains: '不允许使用公共电子邮件域名。',
    duplicated_domains: '存在重复的域名。',
    invalid_domain_format: '无效的域名格式。',
    duplicate_connector_name: '连接器名称已存在。请选择不同的名称。',
};
export default Object.freeze(single_sign_on);
